import { type FunctionComponent, useContext } from 'react';
import { type ImageFieldsFragment, type ThreeSixtyImageFieldsFragment } from '../../../__generated__/graphql-client-types';
import { VariantContext } from '../../../contexts/variant/variant.context';
import { type PdpProductFamily, type PlaProductFamily } from '../../../types/product.types';
import { MediaGallery } from '../../media-gallery/media-gallery.component';
import { BrandLogo } from '../brand-logo/brand-logo.component';

type ProductMediaProps = {
	product: PdpProductFamily | PlaProductFamily;
};

export const ProductMedia: FunctionComponent<ProductMediaProps> = ({ product }) => {
	const { brandInfo, productId, collection, type, media } = product;
	const { selectedVariant, currentVariant } = useContext(VariantContext);

	const variantMedia: (ImageFieldsFragment | ThreeSixtyImageFieldsFragment)[] = [selectedVariant.image];

	if (selectedVariant.threeSixtyImage) {
		variantMedia.push(selectedVariant.threeSixtyImage);
	}

	return (
		<div className={'v-top mt2'}>
			<BrandLogo brandName={brandInfo.name} imageId={brandInfo.logo.id} url={brandInfo.url} bypassLazyLoad={true} />
			<div className="pa2 center relative">
				<MediaGallery
					title={`${brandInfo.name} ${productId} ${collection?.name ?? ''} ${type}`}
					items={[...variantMedia, ...media]}
					variantImageId={selectedVariant.image.id}
					currentVariantImage={currentVariant.image}
				/>
			</div>
		</div>
	);
};
